import React from 'react';
import { useSelector } from 'react-redux';
import UnauthorizedAccess from 'src/helpers/UnauthorizedAccess';
import PayrollPlusNewFunctional from './components/payroll-plus-new-functional';
import './payroll-plus-new.scss';

const AuthorizedAccess = UnauthorizedAccess(PayrollPlusNewFunctional);
const PayrollPlusNew = () => {
	let currentClaims = useSelector((state) => state?.sharedStates?.currentUser?.claims);
	let currentUser = useSelector((state) => state?.sharedStates?.currentUser?.roles[0]?.name);
	return <AuthorizedAccess {...{ currentUser, currentClaims, UserClaims: 'Manage.Payroll' }} />;
};

export default PayrollPlusNew;
